import React from "react";
import semanticVariables from "ui-v2/styles/semantic_colors.module.scss";

export default ({ width = 24, height = 24, color = "primary" }) => {
  const colorValue = semanticVariables?.[`semantic_icon_${color}`];
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M18.8944 18.8944C22.7022 15.0866 22.7022 8.9136 18.8944 5.10583C15.0866 1.29806 8.9136 1.29806 5.10583 5.10583C1.29806 8.9136 1.29806 15.0866 5.10583 18.8944C8.9136 22.7022 15.0866 22.7022 18.8944 18.8944ZM9.34847 8.59893C9.14972 8.59906 8.95914 8.67807 8.8186 8.8186C8.67807 8.95914 8.59906 9.14972 8.59893 9.34847L8.59894 13.5911C8.59538 13.6918 8.61214 13.7921 8.64821 13.8861C8.68427 13.9802 8.73891 14.066 8.80887 14.1385C8.87882 14.2109 8.96265 14.2686 9.05535 14.3079C9.14806 14.3473 9.24775 14.3676 9.34847 14.3676C9.44919 14.3676 9.54887 14.3473 9.64158 14.3079C9.73429 14.2686 9.81812 14.2109 9.88807 14.1385C9.95802 14.066 10.0127 13.9802 10.0487 13.8861C10.0848 13.7921 10.1016 13.6918 10.098 13.5911L10.098 11.1587L14.1214 15.1821C14.2621 15.3228 14.4529 15.4018 14.6518 15.4018C14.8507 15.4018 15.0414 15.3228 15.1821 15.1821C15.3228 15.0414 15.4018 14.8507 15.4018 14.6518C15.4018 14.4529 15.3228 14.2621 15.1821 14.1214L11.1587 10.098L13.5911 10.098C13.7853 10.0911 13.9693 10.0092 14.1043 9.86936C14.2392 9.72955 14.3147 9.5428 14.3147 9.34847C14.3147 9.15414 14.2392 8.96739 14.1043 8.82758C13.9693 8.68776 13.7853 8.60579 13.5911 8.59894L9.34847 8.59893Z"
        fill={colorValue}
      />
    </svg>
  );
};
